import { Chip, type ChipProps } from "@mui/material";
import { formatEnumLabel } from "@utils/format-enum-label";

type Props = Omit<ChipProps, "label"> & {
  label: string;
  upper?: boolean;
  preserveCasing?: boolean;
  capitalise?: boolean;
};

export const EnumChip = ({
  label,
  upper,
  preserveCasing,
  capitalise,
  ...otherProps
}: Props) => {
  let resolvedLabel = label;

  if (upper) {
    resolvedLabel = label.toUpperCase();
  } else if (capitalise) {
    resolvedLabel = formatEnumLabel(label);
  } else if (!preserveCasing) {
    resolvedLabel = label.toLocaleLowerCase().replaceAll("_", "-");
  }

  return <Chip label={resolvedLabel} {...otherProps} />;
};
